// Время публикации новостей и видео словами, как в Figma: «15 minutes ago», «2 hours ago», «1 day ago»; старше недели —
// дата «16 Oct». Слова — встроенный Intl.RelativeTimeFormat языка интерфейса (переводы hi/bn/ta/te у браузера);
// нет его в окружении — свои строки time_passed_*. Цифры латинские, как у formatDate (урок iOS про bn).
import { formatDate, lang as uiLang, t, type Lang, type StringKey } from './i18n';

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MAX_DAYS = 7;

type Unit = 'minute' | 'hour' | 'day';

const FALLBACK: Record<Unit, [one: StringKey, many: StringKey]> = {
  minute: ['time_passed_minute', 'time_passed_minutes'],
  hour: ['time_passed_hour', 'time_passed_hours'],
  day: ['time_passed_day', 'time_passed_days'],
};

function words(value: number, unit: Unit, lang: Lang): string {
  if (typeof Intl !== 'undefined' && typeof Intl.RelativeTimeFormat === 'function') {
    try {
      const locale = `${lang === 'en' ? 'en-IN' : `${lang}-IN`}-u-nu-latn`;
      return new Intl.RelativeTimeFormat(locale, { numeric: 'always' }).format(-value, unit);
    } catch { /* язык не поддержан — свои строки */ }
  }
  const [one, many] = FALLBACK[unit];
  return t(value === 1 ? one : many, value);
}

/** «N minutes ago» до часа, «N hours ago» до суток, «N days ago» от 1 до 7 суток, дальше — дата. Будущее (часы
 *  сервера впереди) — «1 minute ago». Неразборчивая дата — пустая строка (вызывающий её не показывает). */
export function timeAgo(publishedAt: string | Date, now: Date = new Date(), lang: Lang = uiLang): string {
  const date = publishedAt instanceof Date ? publishedAt : new Date(publishedAt);
  if (Number.isNaN(date.getTime())) return '';
  const diff = now.getTime() - date.getTime();
  if (diff < HOUR) return words(Math.max(1, Math.floor(diff / MINUTE)), 'minute', lang);
  if (diff < DAY) return words(Math.floor(diff / HOUR), 'hour', lang);
  const days = Math.floor(diff / DAY);
  if (days <= MAX_DAYS) return words(days, 'day', lang);
  return formatDate(date, { day: 'numeric', month: 'short' });
}
